import { Pagination } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLoad } from "../../context";
import ApiServices from "../../services/apiServices";
import storage from "../../services/storage";
import "./index.css";
import { BsCurrencyDollar } from "react-icons/bs";
import { CiCircleMinus } from "react-icons/ci";
import { Link, useLocation } from "react-router-dom";
import PaginacaoCustomizada from "../../Components/PaginacaoCustomizada";
import CardExtrato from "../../Components/CardExtrato";
export default function MeusPontos() {
  const data = new Date();
  const mesAtual = data.getMonth() + 1;
  const anoAtual = data.getFullYear();
  const location = useLocation();

  const { load, setLoad } = useLoad();
  const [user] = useState(storage.get("USUARIO")?.loginResponse);

  const [tipoTabela, setTipoTabela] = useState(0);
  const [ano, setAno] = useState(anoAtual);
  const [mes, setMes] = useState(null);

  const [selecione, setSelecione] = useState([]);
  const [entradas, setEntradas] = useState([]);
  const [pageSaida, setPageSaida] = useState(1);
  const [pageEntrada, setPageEntrada] = useState(1);
  const [pageExtrato, setPageExtrato] = useState(1);
  const [totalPageExtrato, setTotalPageExtrato] = useState(1);
  const [pageMaisPremios, setPageMaisPremios] = useState(1);
  const [totalPageMaisPremios, setTotalPageMaisPremios] = useState(1);
  const [pageVitrineLeo, setPageVitrineLeo] = useState(1);
  const [totalPageVitrineLeo, setTotalPageVitrineLeo] = useState(1);

  const [saidas, setSaidas] = useState([]);
  const [expirar, setExpirar] = useState([]);
  const [maisPremios, setMaisPremios] = useState([]);
  const [vitrineLeo, setVitrineLeo] = useState([]);
  const [verMais, setVerMais] = useState(10);
  const [extrato, setExtrato] = useState({
    disponivel: "",
    resgate: "",
    expirar30: "",
    creditados: "",
    resgatados: "",
    expirados: "",
  });

  async function fnExpirar() {
    var objEnvio = { CodigoCliente: user.profile.codiCli, Mes: mes, Ano: ano };

    const parametros = {
      page: pageMaisPremios,
      login: user.profile.codiCli,
      ...(ano !== null && ano !== undefined ? { ano: ano } : {}),
      ...(mes !== null && mes !== undefined ? { mes: mes } : {}),
    };
    setLoad(true);

    try {
      setLoad(true);
      const queryString = new URLSearchParams(parametros).toString();
      let response = await ApiServices.apiGet(
        `vitrineorder/extrato-to-expire?${queryString}`,
        objEnvio
      );
      setExpirar(response.data?.items);
      setTotalPageExtrato(response.data?.totalPages);

      toast.error(response.statusCode != 200 && response.message);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  async function fnMaisPremios() {
    var objEnvio = { CodigoCliente: user.profile.codiCli, Mes: mes, Ano: ano };

    const parametros = {
      page: pageMaisPremios,
      login: user.profile.codiCli,
      ...(ano !== null && ano !== undefined ? { ano: ano } : {}),
      ...(mes !== null && mes !== undefined ? { mes: mes } : {}),
    };

    if (ano != null) {
      // Verifica se ano não é nulo ou indefinido
      parametros.ano = ano;
    }

    if (mes != null) {
      // Verifica se mes não é nulo ou indefinido
      parametros.mes = mes;
    }

    setLoad(true);

    try {
      setLoad(true);
      const queryString = new URLSearchParams(parametros).toString();
      let response = await ApiServices.apiGet(
        `vitrineorder/extrato-maisPremios?${queryString}`,
        objEnvio
      );
      setMaisPremios(response.data?.items);
      setTotalPageMaisPremios(response.data?.totalPages);

      toast.error(response.statusCode != 200 && response.message);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  async function fnVitrineLeo() {
    var objEnvio = { CodigoCliente: user.profile.codiCli, Mes: mes, Ano: ano };

    const parametros = {
      page: pageMaisPremios,
      login: user.profile.codiCli,
      ...(ano !== null && ano !== undefined ? { ano: ano } : {}),
      ...(mes !== null && mes !== undefined ? { mes: mes } : {}),
    };

    setLoad(true);

    try {
      setLoad(true);
      const queryString = new URLSearchParams(parametros).toString();
      let response = await ApiServices.apiGet(
        `vitrineorder/extrato-vitrine-leo?${queryString}`,
        objEnvio
      );
      setVitrineLeo(response.data?.items);
      setTotalPageVitrineLeo(response.data?.totalPages);

      toast.error(response.statusCode != 200 && response.message);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  async function fnSaidas() {
    var objEnvio = { codi_cli: user.profile.codiCli, mes: mes, ano: ano };
    try {
      setLoad(true);
      let response = await ApiServices.apiPost(
        "vitrineorder/extratoparticipantesaidahistorico",
        objEnvio
      );
      setSaidas(response.data);
      toast.error(response.statusCode != 200 && response.message);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  async function fnSelecione() {
    var objEnvio = { CodigoCliente: user.profile.codiCli, Mes: mes, Ano: ano};
    try {
      setLoad(true);
      let response = await ApiServices.apiPost(
        "vitrineorder/extratoparticipantetodos",
        objEnvio
        
      );
      setSelecione(response.data);
      toast.error(response.statusCode != 200 && response.message);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  async function fnEntradas() {
    var objEnvio = { CodigoCliente: user.profile.codiCli, Mes: mes, Ano: ano};
    try {
      setLoad(true);
      let response = await ApiServices.apiPost(
        "vitrineorder/extratoparticipanteentradahistorico",
        objEnvio
      );
      setEntradas(response.data);
      toast.error(response.statusCode != 200 && response.message);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  async function fnResumo() {
    var objEnvio = { token: user.token, codigoCliente: user.profile.codiCli};

    try {
      setLoad(true);
      let response = await ApiServices.apiPost(
        "vitrineorder/resumoextratoparticipante",
        objEnvio
      );
      let data = response?.data;
      setExtrato((prevState) => ({
        ...prevState,
        creditados: (
          (data?.creditBalance ?? 0) + (data?.debitBalance ?? 0)
        )?.toLocaleString("pt-br", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      }));
      setExtrato((prevState) => ({
        ...prevState,
        resgatados: response.data?.redeemBalance?.toLocaleString("pt-br", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      }));
      setExtrato((prevState) => ({
        ...prevState,
        resgate: response.data?.lockedBalance?.toLocaleString("pt-br", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      }));
      setExtrato((prevState) => ({
        ...prevState,
        expirados: response.data?.expiredBalance?.toLocaleString("pt-br", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      }));
      toast.error(response.statusCode != 200 && response.message);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  // async function fnPontosExpirados() {
  //   var objEnvio = { token: user.token, codigoCliente: user.profile.codiCli };
  //   try {
  //     let response = await ApiServices.apiPost(
  //       "vitrineorder/pointsExpired",
  //       objEnvio
  //     );
  //     setExtrato((prevState) => ({ ...prevState, expirados: response.data }));
  //     toast.error(response.statusCode != 200 && response.message);
  //   } catch (err) {
  //     console.error("err", err);
  //   } finally {
  //   }
  // }

  async function fnSaldo() {
    var objEnvio = { token: user.token, codigoCliente: user.profile.codiCli};
    try {
      let response = await ApiServices.apiPost("vitrineorder/saldo", objEnvio);
      setExtrato((prevState) => ({
        ...prevState,
        disponivel: response.data?.balance?.toLocaleString("pt-br", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      }));
      toast.error(response.statusCode != 200 && response.message);
    } catch (err) {
      console.error("err", err);
    } finally {
    }
  }

  async function fnPontosExpirados30() {
    var objEnvio = { token: user.token, codi_cli: user.profile.codiCli };
    try {
      let response = await ApiServices.apiPost(
        "vitrineorder/pointsToExpire30Days",
        objEnvio
      );
      setExtrato((prevState) => ({
        ...prevState,
        expirar30: response.data?.toLocaleString("pt-br", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      }));
      toast.error(response.statusCode != 200 && response.message);
    } catch (err) {
      console.error("err", err);
    } finally {
    }
  }

  useEffect(() => {
    setVerMais(10);
  }, [tipoTabela]);

  useEffect(() => {
    fnSelecione();
    fnEntradas();
    fnSaidas();
  }, [ano, mes]);

  useEffect(() => {
    fnResumo();
    // fnPontosExpirados();
    fnSaldo();
    fnPontosExpirados30();
  }, []);

  useEffect(() => {
    fnExpirar();
  }, [pageExtrato, ano, mes]);

  useEffect(() => {
    fnMaisPremios();
  }, [pageMaisPremios, ano, mes]);

  useEffect(() => {}, [pageSaida]);

  useEffect(() => {}, [pageEntrada]);

  useEffect(() => {
    fnVitrineLeo();
  }, [pageVitrineLeo, ano, mes]);

  return (
    <>
      <div className="d-flex justify-content-center extratoContainer">
        <div className="container mx-5 px-5">
          <div className="menuNavegacaoExtrato">
            <div className="headerExtrato">
              <div className="subMenuExtratoLinks">
                <Link
                  to="/extrato/meus-pontos"
                  className={
                    location.pathname === "/extrato/meus-pontos" ? "ativo" : ""
                  }
                >
                  EXTRATO
                </Link>
                <Link
                  to="/transferencia-de-pontos"
                  className={
                    location.pathname === "/transferencia-de-pontos"
                      ? "ativo"
                      : ""
                  }
                >
                  TRANSFERÊNCIA DE PONTOS
                </Link>
              </div>
            </div>
          </div>
          <div className="row mt-5">
            <h2>Extrato</h2>

            {/* Versão Desktop - Grid */}
            <div className="row extratoCardsDesktop">
              <div className="col-lg-3">
                <CardExtrato
                  titulo="Pontos"
                  subtitulo="creditados"
                  valor={extrato.creditados}
                  backgroundColor="#e6f0e7"
                  textColor="#1a5940"
                  borderColor="#8cde93"
                  tracoColor="#1a5940"
                />
              </div>
              <div className="col-lg-3">
                <CardExtrato
                  titulo="Pontos"
                  subtitulo="resgatados"
                  valor={extrato.resgatados}
                  backgroundColor="#ffebee"
                  textColor="#c62828"
                  borderColor="#eb3d3d4b"
                  tracoColor="#c62828"
                />
              </div>
              <div className="col-lg-3">
                <CardExtrato
                  titulo="Saldo"
                  valor={extrato.disponivel}
                  backgroundColor="#fafafa"
                  textColor="#1a5940"
                  borderColor="#8cde93"
                  tracoColor="#1a5940"
                />
              </div>
              <div className="col-lg-3">
                <CardExtrato
                  titulo="Pontos a expirar"
                  subtitulo="em 30 dias"
                  valor={extrato.expirar30}
                  backgroundColor="#fff3e0"
                  textColor="#e65100"
                  borderColor="#faae3c"
                  tracoColor="#e65100"
                />
              </div>
            </div>

            {/* Versão Mobile - Card Único */}
            <div className="extratoCardsMobile">
              <div className="cardExtratoMobile">
                <div className="cardExtratoMobileItem cardExtratoMobileCreditados">
                  <div className="cardExtratoMobileHeader">
                    <div>Pontos</div>
                    <b>creditados</b>
                    <div
                      className="tracoExtratoMobile"
                      style={{ backgroundColor: "#1a5940" }}
                    ></div>
                  </div>
                  <div className="cardExtratoMobileValor" style={{ color: "#1a5940" }}>
                    {extrato.creditados !== null && extrato.creditados !== undefined
                      ? extrato.creditados
                      : "..."}
                  </div>
                </div>
                <div className="cardExtratoMobileItem cardExtratoMobileResgatados">
                  <div className="cardExtratoMobileHeader">
                    <div>Pontos</div>
                    <b>resgatados</b>
                    <div
                      className="tracoExtratoMobile"
                      style={{ backgroundColor: "#c62828" }}
                    ></div>
                  </div>
                  <div className="cardExtratoMobileValor" style={{ color: "#c62828" }}>
                    {extrato.resgatados !== null && extrato.resgatados !== undefined
                      ? extrato.resgatados
                      : "..."}
                  </div>
                </div>
                <div className="cardExtratoMobileItem cardExtratoMobileSaldo">
                  <div className="cardExtratoMobileHeader">
                    <div>Saldo</div>
                    <div
                      className="tracoExtratoMobile"
                      style={{ backgroundColor: "#1a5940" }}
                    ></div>
                  </div>
                  <div className="cardExtratoMobileValor" style={{ color: "#1a5940" }}>
                    {extrato.disponivel !== null && extrato.disponivel !== undefined
                      ? extrato.disponivel
                      : "..."}
                  </div>
                </div>
                <div className="cardExtratoMobileItem cardExtratoMobileExpirar">
                  <div className="cardExtratoMobileHeader">
                    <div>Pontos a expirar</div>
                    <b>em 30 dias</b>
                    <div
                      className="tracoExtratoMobile"
                      style={{ backgroundColor: "#e65100" }}
                    ></div>
                  </div>
                  <div className="cardExtratoMobileValor" style={{ color: "#e65100" }}>
                    {extrato.expirar30 !== null && extrato.expirar30 !== undefined
                      ? extrato.expirar30
                      : "..."}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row"></div>

          <div className="row mt-5 filtrosExtrato">
            <div className="col-md-4 mt-3">
              <select
                className="form-select"
                value={ano ? ano : 0}
                onChange={(e) => {
                  setAno(e.target.value != 0 ? Number(e.target.value) : null);
                }}
              >
                <option value={0}>Ano</option>
                <option value={2021}>2021</option>
                <option value={2022}>2022</option>
                <option value={2023}>2023</option>
                <option value={2024}>2024</option>
                <option value={2025}>2025</option>
                <option value={2026}>2026</option>
              </select>
            </div>
            <div className="col-md-4 mt-3">
              <select
                className="form-select"
                value={mes ? mes : 0}
                onChange={(e) => {
                  setMes(e.target.value != 0 ? Number(e.target.value) : null);
                }}
              >
                <option value={0}>Mês</option>
                <option value={1}>Janeiro</option>
                <option value={2}>Fevereiro</option>
                <option value={3}>Março</option>
                <option value={4}>Abril</option>
                <option value={5}>Maio</option>
                <option value={6}>Junho</option>
                <option value={7}>Julho</option>
                <option value={8}>Agosto</option>
                <option value={9}>Setembro</option>
                <option value={10}>Outubro</option>
                <option value={11}>Novembro</option>
                <option value={12}>Dezembro</option>
              </select>
            </div>
            <div className="col-md-4 mt-3">
              <select
                className="form-select"
                value={tipoTabela}
                onChange={(e) => {
                  setTipoTabela(e.target.value);
                }}
              >
                <option value={0}>Detalhes</option>
                <option value={1}>Entradas</option>
                <option value={2}>Saídas</option>
                <option value={3}>Expirações de Pontos</option>
                <option value={4}>Mais Prêmios</option>
                <option value={5}>Vitrine Leo</option>
              </select>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-md-12 ">
              {/* <h3 className="mt-5">Pontos</h3> */}
              {tipoTabela == 0 && (
                <>
                  <h4>Crédito de Pontos</h4>
                  {selecione?.map(
                    (e, i) =>
                      i < verMais && (
                        <div key={i}>
                          <div>
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <div className="d-flex align-items-center">
                                  <div className="m-3">
                                    {e.value >= 0 ? (
                                      <BsCurrencyDollar
                                        style={{ fontSize: 20, color: "#555" }}
                                      />
                                    ) : (
                                      <CiCircleMinus
                                        style={{ fontSize: 20, color: "#555" }}
                                      />
                                    )}
                                  </div>
                                  <div>
                                    {e.value >= 0
                                      ? "Creditado em " +
                                        moment(e.insertDate).format(
                                          "DD/MM/YYYY HH:mm"
                                        )
                                      : "Debitado em " +
                                        moment(e.insertDate).format(
                                          "DD/MM/YYYY HH:mm"
                                        )}
                                    <div>{e.description}</div>
                                  </div>
                                </div>
                              </div>
                              {i + 1 != selecione?.length && (
                                <div className="linhaVertical"></div>
                              )}
                              <div
                                style={{
                                  color: e.value >= 0 ? "green" : "red",
                                  fontWeight: 900,
                                }}
                              >
                                {e?.value?.toLocaleString("pt-br", {
                                  minimumFractionDigits: 2,
                                })}
                              </div>
                            </div>
                            <br />
                          </div>
                        </div>
                      )
                  )}

                  {selecione?.length <= 0 && (
                    <p className="text-center">
                      {" "}
                      Nenhum dado para o período selecionado{" "}
                    </p>
                  )}
                  <div className="d-flex justify-content-center">
                    {selecione?.length > verMais && (
                      <button
                        onClick={() => {
                          setVerMais(verMais + 10);
                        }}
                        className="btn btn-warning btn-lg"
                        style={{ maxWidth: 200, margin: 20 }}
                      >
                        Ver Mais
                      </button>
                    )}
                  </div>
                </>
              )}
              {tipoTabela == 1 && (
                <>
                  <h4>Pontos Creditados</h4>
                  {entradas
                    .filter(
                      (_, i) =>
                        i < pageEntrada * 10 && i >= pageEntrada * 10 - 10
                    )
                    .map((e, i) => {
                      const index = (pageEntrada - 1) * 10 + i;
                      return (
                        <div key={i}>
                          <div>
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <div className="d-flex align-items-center">
                                  <div className="m-3">
                                    <BsCurrencyDollar
                                      style={{ fontSize: 20, color: "#555" }}
                                    />
                                  </div>
                                  <div>
                                    Creditado em{" "}
                                    {moment(e.insertDate).format(
                                      "DD/MM/YYYY HH:mm"
                                    )}
                                    <div>{e.description}</div>
                                    <div
                                      style={{ fontSize: 12, color: "#666" }}
                                    >
                                      Expira em:{" "}
                                      {moment(e.expirationDate).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {index + 1 != entradas?.length && (
                                <div className="linhaVertical"></div>
                              )}
                              <div
                                style={{
                                  color: "green",
                                  fontWeight: 900,
                                }}
                              >
                                {Number(e.value)?.toLocaleString("pt-br", {
                                  minimumFractionDigits: 2,
                                })}
                              </div>
                            </div>
                            <br />
                          </div>
                        </div>
                      );
                    })}
                  {entradas?.length <= 0 && (
                    <p className="text-center">
                      {" "}
                      Nenhum dado para o período selecionado{" "}
                    </p>
                  )}
                  <PaginacaoCustomizada
                    currentPage={pageEntrada}
                    totalPages={Math.ceil(entradas?.length / 10) || 1}
                    onPageChange={(page) => setPageEntrada(page)}
                    showFirstLast={true}
                    maxVisiblePages={5}
                  />
                </>
              )}
              {tipoTabela == 2 && (
                <>
                  <h4>Pontos Utilizados</h4>
                  {saidas
                    .filter(
                      (_, i) => i < pageSaida * 10 && i >= pageSaida * 10 - 10
                    )
                    .map((e, i) => {
                      const index = (pageSaida - 1) * 10 + i;
                      return (
                        <div key={i}>
                          <div>
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <div className="d-flex align-items-center">
                                  <div className="m-3">
                                    <CiCircleMinus
                                      style={{ fontSize: 20, color: "#555" }}
                                    />
                                  </div>
                                  <div>
                                    Debitado em{" "}
                                    {moment(e.insertDate).format(
                                      "DD/MM/YYYY HH:mm"
                                    )}
                                    <div>{e.description}</div>
                                  </div>
                                </div>
                              </div>
                              {index + 1 != saidas?.length && (
                                <div className="linhaVertical"></div>
                              )}
                              <div
                                style={{
                                  color: "red",
                                  fontWeight: 900,
                                }}
                              >
                                {Number(e.value)?.toLocaleString("pt-br", {
                                  minimumFractionDigits: 2,
                                })}
                              </div>
                            </div>
                            <br />
                          </div>
                        </div>
                      );
                    })}
                  {saidas?.length <= 0 && (
                    <p className="text-center">
                      {" "}
                      Nenhum dado para o período selecionado{" "}
                    </p>
                  )}
                  <PaginacaoCustomizada
                    currentPage={pageSaida}
                    totalPages={Math.ceil(saidas?.length / 10) || 1}
                    onPageChange={(page) => setPageSaida(page)}
                    showFirstLast={true}
                    maxVisiblePages={5}
                  />
                </>
              )}
              {tipoTabela == 3 && (
                <>
                  <h4>Expirações de Pontos</h4>
                  <br></br>
                  <h5>
                    <em>
                      * Os pontos podem ser utilizados até a data informada
                      neste Extrato.
                    </em>
                  </h5>
                  {expirar?.map(
                    (e, i) =>
                      i < verMais && (
                        <div key={i}>
                          <div>
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <div className="d-flex align-items-center">
                                  <div className="m-3">
                                    <BsCurrencyDollar
                                      style={{ fontSize: 20, color: "#555" }}
                                    />
                                  </div>
                                  <div>
                                    Expira em{" "}
                                    {moment(e.expirationDateFinal)
                                      .add(1, "days")
                                      .format("DD/MM/YYYY HH:mm")}
                                    <div>{e.description}</div>
                                  </div>
                                </div>
                              </div>
                              {i + 1 != expirar?.length && (
                                <div className="linhaVertical"></div>
                              )}
                              <div
                                style={{
                                  color: "#e65100",
                                  fontWeight: 900,
                                }}
                              >
                                {Number(e.expiredCredits)?.toLocaleString(
                                  "pt-br",
                                  {
                                    minimumFractionDigits: 2,
                                  }
                                )}
                              </div>
                            </div>
                            <br />
                          </div>
                        </div>
                      )
                  )}
                  {expirar?.length < 1 && (
                    <p className="text-center">
                      {" "}
                      Nenhum dado para o período selecionado{" "}
                    </p>
                  )}
                  <div className="d-flex justify-content-center">
                    {expirar?.length > verMais && (
                      <button
                        onClick={() => {
                          setVerMais(verMais + 10);
                        }}
                        className="btn btn-warning btn-lg"
                        style={{ maxWidth: 200, margin: 20 }}
                      >
                        Ver Mais
                      </button>
                    )}
                  </div>
                  <PaginacaoCustomizada
                    currentPage={pageExtrato}
                    totalPages={totalPageExtrato || 1}
                    onPageChange={(page) => setPageExtrato(page)}
                    showFirstLast={true}
                    maxVisiblePages={5}
                  />
                </>
              )}
              {tipoTabela == 4 && (
                <>
                  <h4>Mais Prêmios</h4>
                  {maisPremios?.map(
                    (e, i) =>
                      i < verMais && (
                        <div key={i}>
                          <div>
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <div className="d-flex align-items-center">
                                  <div className="m-3">
                                    <CiCircleMinus
                                      style={{ fontSize: 20, color: "#555" }}
                                    />
                                  </div>
                                  <div>
                                    Debitado em{" "}
                                    {moment(e.orderDate).format("DD/MM/YYYY HH:mm")}
                                    <div>{e.productName}</div>
                                    <div
                                      style={{ fontSize: 12, color: "#666" }}
                                    >
                                      Pedido: {e.orderId} | Parceiro:{" "}
                                      {e.supplierName}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {i + 1 != maisPremios?.length && (
                                <div className="linhaVertical"></div>
                              )}
                              <div
                                style={{
                                  color: "red",
                                  fontWeight: 900,
                                }}
                              >
                                {Number(e.totalOrderValue)?.toLocaleString(
                                  "pt-br",
                                  {
                                    minimumFractionDigits: 2,
                                  }
                                )}
                              </div>
                            </div>
                            <br />
                          </div>
                        </div>
                      )
                  )}
                  {maisPremios?.length < 1 && (
                    <p className="text-center">
                      {" "}
                      Nenhum dado para o período selecionado{" "}
                    </p>
                  )}
                  <div className="d-flex justify-content-center">
                    {maisPremios?.length > verMais && (
                      <button
                        onClick={() => {
                          setVerMais(verMais + 10);
                        }}
                        className="btn btn-warning btn-lg"
                        style={{ maxWidth: 200, margin: 20 }}
                      >
                        Ver Mais
                      </button>
                    )}
                  </div>
                  <PaginacaoCustomizada
                    currentPage={pageMaisPremios}
                    totalPages={totalPageMaisPremios || 1}
                    onPageChange={(page) => setPageMaisPremios(page)}
                    showFirstLast={true}
                    maxVisiblePages={5}
                  />
                </>
              )}
              {tipoTabela == 5 && (
                <>
                  <h4>Vitrine Leo</h4>
                  {vitrineLeo?.map(
                    (e, i) =>
                      i < verMais && (
                        <div key={i}>
                          <div>
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <div className="d-flex align-items-center">
                                  <div className="m-3">
                                    <CiCircleMinus
                                      style={{ fontSize: 20, color: "#555" }}
                                    />
                                  </div>
                                  <div>
                                    Debitado em{" "}
                                    {moment(e.dataCadastro).format("DD/MM/YYYY HH:mm")}
                                    <div>{e.message}</div>
                                    <div
                                      style={{ fontSize: 12, color: "#666" }}
                                    >
                                      Voucher: {e.token}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {i + 1 != vitrineLeo?.length && (
                                <div className="linhaVertical"></div>
                              )}
                              <div
                                style={{
                                  color: "red",
                                  fontWeight: 900,
                                }}
                              >
                                {Number(e.points)?.toLocaleString("pt-br", {
                                  minimumFractionDigits: 2,
                                })}
                              </div>
                            </div>
                            <br />
                          </div>
                        </div>
                      )
                  )}
                  {vitrineLeo?.length < 1 && (
                    <p className="text-center">
                      {" "}
                      Nenhum dado para o período selecionado{" "}
                    </p>
                  )}
                  <div className="d-flex justify-content-center">
                    {vitrineLeo?.length > verMais && (
                      <button
                        onClick={() => {
                          setVerMais(verMais + 10);
                        }}
                        className="btn btn-warning btn-lg"
                        style={{ maxWidth: 200, margin: 20 }}
                      >
                        Ver Mais
                      </button>
                    )}
                  </div>
                  <PaginacaoCustomizada
                    currentPage={pageVitrineLeo}
                    totalPages={totalPageVitrineLeo || 1}
                    onPageChange={(page) => setPageVitrineLeo(page)}
                    showFirstLast={true}
                    maxVisiblePages={5}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
